import { FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useState } from "react";

export const SelectCustomWithOther = (props) => {
    
    const onTrigger = (event) => {
        // event.target.value === "" ? setOnError(true) : setOnError(false);
        
        if (event.target.value === " ") {
            setShowOther(true);
        } else {
            setShowOther(false);
        };
        props.parentCallback(event)
    };

    const handleTextFieldChange = (event) => {
        props.parentCallback(event);
    }

    const [value] = useState("");
    const [onError, setOnError] = useState(false);
    const [showOther, setShowOther] = useState(false);

    return (
        <Grid container spacing={1} sx={{ pl: props.paddingH, pr: props.paddingH, pt: props.paddingV, pb: props.paddingV }}>
            <Grid item xs={props.inputWidth ?? 6}>
                <FormControl 
                    fullWidth 
                    size="small" 
                    required={props.required} 
                    variant={props.variant}
                >
                    <InputLabel id="select-label">{props.label}</InputLabel>
                    <Select
                        defaultValue={value}
                        // error={OnError}
                        id={props.name}
                        label={props.label}
                        name={props.name}
                        onChange={onTrigger}
                        onBlur={ ({ target }) => setOnError(target.value === '') }
                        // onBlur={ ({ target }) => target.value === '' ? setOnError(true) : setOnError(false) }

                        // onBlur={ ({ target }) => console.log({target}) }
                        // onBlur={ (event) => event.target.value === " " ? setOnError(true) : setOnError(false) }
                        error={ onError }
                    >
                        {props.options.map((opt) => {
                            return (
                                <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                </MenuItem>
                            );
                        })};
                        <MenuItem key={"otro"} value={" "}>Otro</MenuItem>
                    </Select>
                    {
                        onError && <Typography fontSize={ 12 } pt={ 0.5 } pl={ 1.5 } color='error'>Este campo es requerido</Typography>
                    }
                </FormControl>
            </Grid>
            {   (showOther) &&
                <Grid item xs={props.inputWidth ?? 6}>
                    <TextField
                        fullWidth
                        label={`Especificar`}
                        name={props.name}
                        size="small"
                        onChange={handleTextFieldChange}
                        variant={props.variant}
                        required={props.required} 
                    />
                </Grid>
            }
        </Grid>
    );
}
